/**
 * IDs de causalidade para lineage e debug.
 */

import type { SendEventParams } from '../../utils/sendEvent';

export interface CausalityFields {
  causation_id?: string;
  correlation_id?: string;
  parent_event_id?: string;
  journey_id?: string;
}

const correlationByPage = new Map<string, string>();
const lastConversionBySession = new Map<string, string>();

function pageKey(sessionId: string): string {
  if (typeof window === 'undefined') return sessionId;
  return `${sessionId}|${window.location.pathname}`;
}

export function enrichCausality(
  params: SendEventParams,
  options?: { causationId?: string; parentEventId?: string }
): SendEventParams {
  const pk = pageKey(params.sessionId);
  let correlationId = correlationByPage.get(pk);
  if (!correlationId) {
    correlationId = `corr_${params.sessionId}_${Date.now()}`;
    correlationByPage.set(pk, correlationId);
  }
  const journeyId = params.sessionId;
  const parent =
    options?.parentEventId ??
    lastConversionBySession.get(params.sessionId);
  const eventData = {
    ...params.eventData,
    correlation_id: correlationId,
    journey_id: journeyId,
    ...(parent ? { parent_event_id: parent } : {}),
    ...(options?.causationId ? { causation_id: options.causationId } : {}),
  };
  return { ...params, eventData };
}

export function noteConversionEvent(sessionId: string, eventId: string): void {
  lastConversionBySession.set(sessionId, eventId);
}

export function _testResetCausality(): void {
  correlationByPage.clear();
  lastConversionBySession.clear();
}
